import { useEffect } from "react";
import useInterfaceSoundCore from "@/shared/hooks/useInterfaceSoundCore";
import { Soundtrack } from "@/shared/sounds";
import Modal from "@/shared/ui/modal/Modal";

export type SoundModalProps = React.ComponentProps<typeof Modal> & {
  openSound?: Soundtrack;
  closeSound?: Soundtrack;
};

export default function SoundModal({
  openSound = Soundtrack.OpenModal,
  closeSound = Soundtrack.Swipe,
  ...props
}: SoundModalProps) {
  const { play: playOpenSound } = useInterfaceSoundCore(openSound);
  const { play: playCloseSound } = useInterfaceSoundCore(closeSound);

  useEffect(() => {
    if (props.open) {
      playOpenSound();
    } else {
      playCloseSound();
    }
  }, [playCloseSound, playOpenSound, props.open]);

  return <Modal {...props} />;
}
